import React from "react";
import { Flex } from "@jsq/ds/core";
import classNames from "classnames";
import { useIsXLScreenLogin } from "apps/login/LoginPage/hooks/useIsXLScreenLogin";
import jsqLogo from "../jsq_logo.svg";
import styles from "./styles.scss";
import { imageIsSquareish } from "../../authentication/Layout";
import { type LogoContainerProps } from "./types";

function LogoContainer(props: LogoContainerProps) {
  let logo: React.ReactElement | null = null;
  const [isSquareLogo, setIsSquareLogo] = React.useState(false);
  const [showLogoImage, setShowLogoImage] = React.useState(false);
  const xl = useIsXLScreenLogin();
  const { logoUrl } = props;

  // Get the size of the image and check if it's squareish
  React.useEffect(() => {
    if (logoUrl) {
      const img = document.createElement("img");
      img.src = logoUrl;
      const poll = setInterval(() => {
        if (img.naturalWidth) {
          clearInterval(poll);
          if (imageIsSquareish(img.naturalWidth, img.naturalHeight)) {
            setIsSquareLogo(true);
          }
        }
      }, 10);
      // Only show the image after it's loaded to ensure it only renders at its final size
      img.onload = () => {
        setShowLogoImage(true);
      };
    }
  }, [logoUrl]);

  if (logoUrl) {
    if (showLogoImage) {
      logo = (
        <img
          className={classNames({
            [styles.LogoContainer__brandLogo]: true,
            [styles.LogoContainer__brandLogoSquare]: isSquareLogo,
          })}
          alt="manager"
          data-testid="logo_img"
          data-cy="brand-img"
          src={logoUrl}
        />
      );
    }
  } else if (props.arenaName) {
    logo = (
      <h1
        className={classNames("h1", styles.LogoContainer__fallBackName)}
        data-testid="logo_text"
        data-cy="arena-name-logo"
      >
        {props.arenaName}
      </h1>
    );
  } else {
    logo = (
      <img
        className={styles.LogoContainer__brandLogo}
        alt="Juniper square logo"
        src={jsqLogo}
      />
    );
  }
  return (
    <Flex
      className={classNames({
        [styles.LogoContainer__wrapperSmToMd]: !xl,
        [styles.LogoContainer__wrapperLg]: xl,
      })}
    >
      {logo}
    </Flex>
  );
}

export default LogoContainer;
